import React, { useState } from "react";
import { Loader, Modal, Button, ButtonToolbar } from "rsuite";

import HttpService from "../../../services/HttpService";

import transactionIcon from "/public/images/transaction.svg";

const APP_URL = process.env.APP_URL;

export const UserTransactions = () => {
  const [open, setOpen] = useState(false);
  const [, setSize] = useState();
  const [transactions, setTransactions] = useState();

  function trackingCode(transaction) {
    return transaction.transaction_status === 2 ||
      transaction.payment.status === 2 ? (
      <>
        <span className="follow-up">کد پیگیری : </span>
        <span className="follow-up flex-1 text-end break-all">
          {transaction.tracking_code}
        </span>
      </>
    ) : (
      <span className="follow-up flex-1 text-start break-all">
        {transaction.description}
      </span>
    );
  }

  const handleOpen = (value) => {
    setSize(value);
    setOpen(true);
    HttpService.get(`${APP_URL}/api/v6/gateway-transactions`).then(
      (response) => {
        const transactions = response.data.data;
        let data = transactions.map((transaction, index) => (
          <div className="transactions">
            <div className="icon">
              <img src={transaction.image} alt="تراکنش کاربر" />
            </div>
            <div className="item">
              <div className="title flex-wrap">
                <div>{transaction.title}</div>
                <div
                  className={transaction?.currency !== "تومان" && "font-mono"}
                >
                  {transaction.amount} {transaction?.currency}
                </div>
              </div>
              <div className="date">
                {transaction.updated_at.date} ساعت {transaction.updated_at.time}
              </div>
              <div className="follow-up flex flex-wrap gap-1 justify-between max-md:flex-col">
                {trackingCode(transaction)}
              </div>
            </div>
          </div>
        ));
        setTransactions(data);
      }
    );
  };
  const handleClose = () => setOpen(false);

  return (
    <div>
      <ButtonToolbar>
        <Button
          size="xs"
          onClick={() => handleOpen("xs")}
          className="transaction-button"
        >
          <div className="d-flex align-items-center">
            <div className="img">
              <img src={transactionIcon} alt="تراکنش های کاربر" />
            </div>
            <div className="text"> تراکنش ها</div>
          </div>
        </Button>
      </ButtonToolbar>
      <Modal className={"transaction-modal"} open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong className="transaction-title">سوابق خرید</strong>
          <div className="transactions-container">
            {transactions ? (
              transactions
            ) : (
              <>
                <Loader backdrop content="درحال دریافت اطلاعات ..." vertical />
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
